<script setup lang="ts">
  import { IItem } from '@/interfaces/IItem';
  import { inject, Ref, computed, ref, watch } from 'vue';
  import StoreMenuItemOptionsBlock from './StoreMenuItemOptionsBlock.vue';

  const props = defineProps<{
    value: Record<number, Record<number, number>>;
    onlyDisplay?: boolean;
  }>();
  const emit = defineEmits(['input']);

  const item = inject<Ref<IItem | null>>('item')!;

  const priceVariants = computed(() => {
    if (!item.value) return null;

    return item.value.options?.[0];
  });

  //console.log("modelValue", JSON.stringify(props.modelValue));

  const activeOptions = computed(() => {
    return item.value?.itemOptions?.filter((option) => option.active) ?? [];
  });

  const optionsValues = ref<Record<number, Record<number, number>> | null>(
    props.value ? JSON.parse(JSON.stringify(props.value)) : null
  );

  watch(
    item,
    () => {
      if (!item.value || !priceVariants.value) return;

      const oV: Record<number, Record<number, number>> = {};

      if (priceVariants.value?.active) {
        oV[priceVariants.value.id!] = {};
      }

      for (const option of activeOptions.value) {
        oV[option.optionId!] = {};
      }

      if (props.value) {
        for (const optionId in props.value) {
          oV[+optionId] = props.value[+optionId];
        }
      }

      /*console.log("item changes", {
        optionsValues: JSON.stringify(optionsValues.value),
        oV: JSON.stringify(oV),
      });*/

      optionsValues.value = oV;
    },
    { immediate: true }
  );

  watch(
    () => props.value,
    (newValue) => {
      //console.log("on model value change", JSON.stringify(newValue));
      optionsValues.value = newValue;
    }
  );

  watch(
    optionsValues,
    () => {
      /*console.log(
        "on optionsValues change",
        JSON.stringify(optionsValues.value)
      );*/
      emit('input', optionsValues.value);
    },
    { deep: true }
  );
</script>

<template>
  <div class="store-item-options">
    <template v-if="optionsValues">
      <StoreMenuItemOptionsBlock
        v-if="priceVariants?.active"
        v-model="optionsValues[priceVariants.id]"
        :option="priceVariants"
        :only-display="onlyDisplay"
      />
      <template v-if="item?.itemOptions">
        <StoreMenuItemOptionsBlock
          v-for="option in activeOptions"
          :key="option.index"
          v-model="optionsValues[option.optionId]"
          :option="option"
          :only-display="onlyDisplay"
        />
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss"></style>
